import { render, staticRenderFns } from "./CreateOrgButtons.vue?vue&type=template&id=4e027ffc&scoped=true&"
import script from "./CreateOrgButtons.vue?vue&type=script&lang=ts&"
export * from "./CreateOrgButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e027ffc",
  null
  
)

export default component.exports